<template>
  <v-container>
    <div>
      <v-row justify="space-between">
        <v-col cols="12" sm="5" justify="center">
          <p class="header-title"> {{ $t('target.approve_target_list') }} </p>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-data-table :headers="headers" :items="desserts" :search="search" class="elevation-1" hide-default-footer
                  :page.sync="page" :loading="loading" :items-per-page="itemsPerPage" @page-count="pageCount = $event">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name"
                              v-bind:label="$t('location_assign.select_province')" return-object outlined
                              dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectDistrict" :items="districts" item-text="district_name"
                              v-bind:label="$t('location_assign.select_district')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectOrderUnit" :items="orderUnits" item-text="name"
                              v-bind:label="$t('location_assign.order_unit')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="5">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
          <!-- </v-container> -->
        </v-toolbar>

      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-btn color="primary" dark @click="approveTarget(item)">
          {{ $t('target.approve') }}
        </v-btn>
      </template>

      <template v-slot:[`item.orderUnit`]="{ item }">
        <div class="contentAddress">
          <span>
                {{item.orderUnit.name}}
          </span>
        </div>
      </template>

      <template v-slot:[`item.createdBy`]="{ item }">
        <div class="contentAddress">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.createdBy.avatar" :src="baseImage + item.createdBy.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.createdBy.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.createdBy.nickname }}
              </span>
        </div>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    overlay: false,
    isSearching: false,

    show: false,
    e1: 0,
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    isEdit: false,

    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    modal: false,

    firstEdit: true,
    search: '',
    dialog: false,

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index'},
      {text: i18n.t('target.name'), value: 'name'},
      {text: i18n.t('target.order_unit'), value: 'orderUnit'},
      {text: '', sortable: false, value: 'orderUnit.name', align: ' d-none'},

      // {text: i18n.t('target.competitor'), value: 'competitor'},
      // {text: '', sortable: false, value: 'competitor.name', align: ' d-none'},

      {text: i18n.t('target.created_by'), value: 'createdBy'},
      {text: '', sortable: false, value: 'createdBy.fullname', align: ' d-none'},

      // {text: i18n.t('target.status'), value: 'status'},

      {text: '', value: 'action', sortable: false}
    ],

    desserts: [],
    originalDesserts: [],

    editedIndex: -1,
    editedItem: null,
    defaultItem: {},

    provinces: [],
    selectProvince: {},

    selectDistrict: null,
    districts: [],

    selectOrderUnit: null,
    orderUnits: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('staff_management.add_management') : i18n.t('staff_management.edit_management')
    },

    computedDateFormatted() {
      return this.formatDate(this.date)
    },
  },

  components: {
  },

  watch: {
    selectProvince(val) {
      if (val) {
        this.getDistrictByProvinceID(val.province_id);
      }
    },
    //
    selectDistrict(val) {
      if (val) {
        this.getOrderUnitByDistrict(val._id);
      }
    },

    selectOrderUnit(val) {
      if (val) {
        this.filterData();
      }
    }
  },

  async created() {
    await this.getProvince();
    await this.getData();

    this.isSearching = true;
  },

  async mounted() {

  },

  methods: {
    initialize() {
    },

    filterData() {
      if (!this.originalDesserts || this.originalDesserts.length == 0) {
        return;
      }

      const self = this;

      if (this.selectProvince) {
        this.desserts = [].concat(this.originalDesserts.filter(item => self.selectProvince._id === item.orderUnit.vtProvince._id));
      }

      if (self.selectDistrict._id !== "-1") {
        self.desserts = [].concat(self.desserts.filter(function(item) {
          if (item.orderUnit.vtDistrict) {
            return item.orderUnit.vtDistrict._id === self.selectDistrict._id;
          }
        }));
      }

      if (self.selectOrderUnit._id !== "-1") {
        self.desserts = [].concat(self.desserts.filter(function(item) {
          if (item.orderUnit) {
            return item.orderUnit._id === self.selectOrderUnit.v;
          }
        }));
      }

      this.desserts.forEach((item, index) => item.index = index + 1);
    },

    async getData() {
      this.overlay = this.isSearching;
      try {
        if (this.$isAdmin) {
          this.originalDesserts = await this.$getAllApproveTargets();
        } else {
          if (this.$getUserCategory === 1) {
            this.originalDesserts = await this.$getApproveTargetOfMine();
          } else {
            this.originalDesserts = await this.$getApproveTargetInContext();
          }
        }

        console.log(this.originalDesserts);

        this.overlay = false;
        this.loading = false;

        this.filterData();
      } catch (e) {
        console.log(e.stack);
      }
    },

    async approveTarget(item) {
      const agree = confirm(i18n.t('common.confirm_approve_target'));

      if (agree) {
        item.status  =1
        const response = await this.$http.put('target/' + item._id, item);
        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.getData();
          });
        }
      }

    },

    getStringByStatus(value) {
      if (value == 0) {
        return i18n.t('target.not_occupied')
      } else if (value == 1) {
        return i18n.t('target.occupied')
      } else {
        return i18n.t('target.captured')
      }
    },

    getStringByActivate(value) {
      if (value == 0) {
        return i18n.t('target.unapproved')
      } else if (value == 1) {
        return i18n.t('target.approved')
      }
    },

    async getOrderUnitByDistrict(districtId) {
      let contextArr;
      if (districtId === "-1") {
        contextArr = await this.$getAllOrderUnitByProvince(this.selectProvince._id);
      } else {
        contextArr = await this.$getAllOrderUnitByDistrict(districtId);
      }

      const optionAll = {
        name : "Tất cả",
        _id : "-1"
      }

      this.selectOrderUnit = optionAll;
      this.orderUnits = [optionAll].concat(contextArr);
    },

    // async getProvince() {
    //   if (this.$isAdmin) {
    //     this.provinces = await this.$getAllProvinces();
    //
    //   } else {
    //     if (this.$getUserCategory === 3 ) {
    //       this.provinces = await this.$getProvincesByContext(this.$getUserContextID);
    //       if (this.provinces.length > 0) {
    //         this.selectProvince = this.provinces[0];
    //       }
    //     } else if (this.$getUserCategory === 2 ) {
    //       const data = await this.$getDetailContext(this.$getUserContextID);
    //       const contextDepartment = data.parents[1];
    //
    //       this.provinces = await this.$getProvincesByContext(contextDepartment._id);
    //     }
    //   }
    //
    //   if (this.provinces.length > 0) {
    //     this.selectProvince = this.provinces[0];
    //   }
    // },
    //
    // async getDistrictByProvinceID(provinceId) {
    //   if (this.$isAdmin || this.$getUserCategory === 3) {
    //     this.districts = await this.$getDistrictByProvince(provinceId);
    //     if (this.districts.length > 0) {
    //       this.selectDistrict = this.districts[0];
    //     }
    //   } else {
    //     this.districts = await this.$getDistrictByContext(this.$getUserContextID, this.selectProvince.province_id);
    //
    //     if (this.districts.length > 0) {
    //       this.selectDistrict = this.districts[0];
    //     }
    //   }
    // },
    async getProvince() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
        if (response.data && response.data.success) {
          this.provinces = response.data.data;
          this.selectProvince = this.provinces[0];
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getDistrictByProvinceID(provinceId) {
      try {
        // const response =  await this.$http.get('/province/province/' + provinceId);
        const response = await this.$http.get(process.env.VUE_APP_VT_DISTRICT_API + provinceId);
        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          const optionAll = {
            district_name : "Tất cả",
            _id : "-1"
          }

          this.selectDistrict = optionAll;
          this.districts = [optionAll].concat(contextArr);
        }

      } catch (e) {
        console.log(e.stack);
      }
    },
  },
}
</script>

<style scoped>

.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>
